import i18n from '../i18n';

export default {
  getSkuTypes: () => ({
    blush: {
      type: 'BLUSH',
      name: i18n.t('globals.skutypes.blush.name', 'Blush'),
    },
    eyelashes: {
      type: 'EYELASHES',
      name: i18n.t('globals.skutypes.eyelashes.name', 'Eyelashes'),
    },
    eyeliner: {
      type: 'EYELINER',
      name: i18n.t('globals.skutypes.eyeliner.name', 'Eye Liner'),
    },
    eyeshadow: {
      type: 'EYESHADOW',
      name: i18n.t('globals.skutypes.eyeshadow.name', 'Eye Shadow'),
    },
    foundation: {
      type: 'FOUNDATION',
      name: i18n.t('globals.skutypes.foundation.name', 'Foundation'),
    },
    lipcolor: {
      type: 'LIPCOLOR',
      name: i18n.t('globals.skutypes.lipcolor.name', 'Lip Color'),
    },
    mascara: {
      type: 'MASCARA',
      name: i18n.t('globals.skutypes.mascara.name', 'Mascara'),
    },
  }),
  getSkuTypeOptions: () => [
    {
      value: 'BLUSH',
      label: i18n.t('globals.skutypes.blush.name', 'Blush'),
      optionClassName: 'skutypeoption__blush',
    },
    {
      value: 'EYELASHES',
      label: i18n.t('globals.skutypes.eyelashes.name', 'Eyelashes'),
      optionClassName: 'skutypeoption__eyelashes',
    },
    {
      value: 'EYELINER',
      label: i18n.t('globals.skutypes.eyeliner.name', 'Eye Liner'),
      optionClassName: 'skutypeoption__eyeliner',
    },
    {
      value: 'EYESHADOW',
      label: i18n.t('globals.skutypes.eyeshadow.name', 'Eye Shadow'),
      optionClassName: 'skutypeoption__eyeshadow',
    },
    {
      value: 'FOUNDATION',
      label: i18n.t('globals.skutypes.foundation.name', 'Foundation'),
      optionClassName: 'skutypeoption__foundation',
    },
    {
      value: 'LIPCOLOR',
      label: i18n.t('globals.skutypes.lipcolor.name', 'Lip Color'),
      optionClassName: 'skutypeoption__lipstick',
    },
    {
      value: 'MASCARA',
      label: i18n.t('globals.skutypes.mascara.name', 'Mascara'),
      optionClassName: 'skutypeoption__mascara',
    },
  ],
  getSkuTypeName: type => {
    if (!type) return '';

    const t = type.toUpperCase();
    switch (t) {
      case 'BLUSH':
        return i18n.t('globals.skutypes.blush.name', 'Blush');
      case 'EYELASHES':
        return i18n.t('globals.skutypes.eyelashes.name', 'Eyelashes');
      case 'EYELINER':
        return i18n.t('globals.skutypes.eyeliner.name', 'Eye Liner');
      case 'EYESHADOW':
        return i18n.t('globals.skutypes.eyeshadow.name', 'Eye Shadow');
      case 'FOUNDATION':
        return i18n.t('globals.skutypes.foundation.name', 'Foundation');
      case 'LIPCOLOR':
      case 'LIPSTICK':
        return i18n.t('globals.skutypes.lipcolor.name', 'Lip Color');
      case 'MASCARA':
        return i18n.t('globals.skutypes.mascara.name', 'Mascara');
      case 'EYEWEAR':
        return i18n.t('p.e.eyewear.title', 'Eyewear');
      default:
        return type;
    }
  },
};
